<template>
  <div class="radio radio--info text-center">
    <h3 class="mb-0">
      {{ $t("radioInfoTitle") }}
    </h3>
    <p class="font-weight-light" v-html="$t('radioInfoText')" />
    <div class="radio--info__imageWrapper">
      <img src="@/assets/icons/radio/img-pan-radio-waving.svg" />
    </div>
    <p>
      <router-link :to="{ path: `/profile` }">
        {{ $t("doNastaveni") }}
      </router-link>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
